import { Link } from 'react-router-dom';
//import logo from './../assets/img/totalsolar-wg.png'
import { ASSETS_URL } from '../utils/constants';

const logo = ASSETS_URL + 'totalsolar-wg.png'
const logo2 = ASSETS_URL + 'totalsolar_logo_lite.png'

const linkStyles= `
    px-2 
    font-semibold
    whitespace-nowrap
    text-white hover:text-[#4CB117] hover:cursor-pointer hover:border-b-[2px] hover:border-[#4CB117]
`

function Footer() {
    return (
        <footer className='font-[Montserrat] w-full text-white bg-[#212121] flex justify-center p-10'>
            <div className="flex flex-col-reverse md:flex-row w-[80%] justify-between">
                <div className='flex flex-col items-center md:items-start'>
                    <Link to={'/'}>
                        <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="w-[60px]" src={logo2}/>
                    </Link>
                    
                    <p className='text-white text-center md:text-left text-xs'>Copyright © Total Solar Installation 2023<br/>All rights reserved</p>
                </div>
                
                <div className="flex flex-wrap flex-col md:flex-row items-center ">
                    <Link to={'/'} className={linkStyles}>Home</Link>
                    <Link to={'/about'} className={linkStyles}>About</Link>
                    <Link to={'/services'} className={linkStyles}>Services</Link>

                    <Link to={'/products'} className={linkStyles}>Products</Link>
                    <Link to={'/projects'} className={linkStyles}>Projects</Link>
                    {/* <Link to={'/careers'} className={linkStyles}>Careers</Link> */}
                    <Link to={'/contact'} className={linkStyles}>Contact Us</Link>
                    <Link to={'/privacy-policy'} className={linkStyles}>Policy Statement</Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;